export default {
  desktop: 896,
  largeDesktop: 1100,
};
